import gql from 'graphql-tag';

import dokkioUserFragment from '../fragments/dokkioUserFragment';

export const queryDokkioUser = gql`
  query dokkioUser($id: DokkioID) {
    dokkioUser(id: $id) {
      ...dokkioUserFragment
    }
  }
  ${dokkioUserFragment}
`;
export default queryDokkioUser;
